// Dropdown component for changing the language used in the header of the dashboard.
// imported in ../DashboardHeader/DashboardHeader.js
import React from "react";
import "../../../../../Assets/Styles/ProfileMenu.scss";

const LanguageMenu = (props) => {
  return (
    <>
      <div className="profile-menu-outline" onClick={() => props.Close()}></div>
      <div className="profile-menu language-menu">
        <div className="language-menu-actions">
          <section
            className={
              props.SelectedLanguage === "EN"
                ? "action-item active-item"
                : "action-item"
            }
            onClick={() => props.SetLanguage("EN")}
          >
            <p>English</p>
            <i className="feather-check"></i>
          </section>
          <section
            className={
              props.SelectedLanguage === "DE"
                ? "action-item active-item"
                : "action-item"
            }
            onClick={() => props.SetLanguage("DE")}
          >
            <p>Deutsch</p>
            <i className="feather-check"></i>
          </section>
        </div>
      </div>
    </>
  );
};

export default LanguageMenu;
